import cn from 'classnames';
import parse from 'html-react-parser';
import { FC } from 'react';

import {
  cleanBuilderParagraphInput,
  cleanBuilderStringInput,
  getBuilderString,
  isBuilderStringPresent,
} from '@/shared/text';
import { BuilderString } from '@/shared/types';

import { Action, ActionVariant, BaseAction } from '../Action';
import style from './Header.module.scss';

export interface Props {
  title?: BuilderString;
  titleSpacingClassName?: string;
  description?: BuilderString;
  fullWidth?: boolean;
  locale: string;
  action?: BaseAction;
  actionVariant?: ActionVariant;
  headerClassName?: string;
}

export const Header: FC<Props> = ({
  title,
  titleSpacingClassName = 'u-m-b-xl u-m-b-lg-xxl-6',
  description,
  action = { label: '', url: '' },
  actionVariant = ActionVariant.NONE,
  fullWidth,
  locale,
  headerClassName,
}) => {
  if (
    !(
      isBuilderStringPresent(title, locale) ||
      isBuilderStringPresent(description, locale)
    ) &&
    (actionVariant === ActionVariant.NONE ||
      !isBuilderStringPresent(action.label, locale))
  ) {
    return null;
  }

  return (
    <header
      data-testid="header"
      className={cn(style.header, headerClassName, {
        'tw:hidden tw:md:block': !(
          isBuilderStringPresent(title, locale) ||
          isBuilderStringPresent(description, locale)
        ),
      })}
    >
      <div
        className={cn(style.title, {
          'tw:hidden':
            !isBuilderStringPresent(title, locale) &&
            actionVariant === ActionVariant.NONE,
          'tw:hidden tw:md:block':
            !isBuilderStringPresent(title, locale) &&
            actionVariant !== ActionVariant.NONE,
          [titleSpacingClassName]: isBuilderStringPresent(description, locale),
        })}
      >
        <div
          data-testid="title"
          className={cn('u-typography-h2', {
            [style.shrink]: fullWidth === false,
          })}
        >
          {parse(cleanBuilderStringInput(getBuilderString(title, locale)))}
        </div>
        <Action
          className={style.button}
          {...action}
          locale={locale}
          variant={actionVariant}
        />
      </div>
      <div
        data-testid="description"
        className={cn('u-typography-h3', 'tw:text-neutral-secondary', {
          'tw:hidden': !isBuilderStringPresent(description, locale),
          [style.shrink]: fullWidth === false,
        })}
      >
        {parse(
          cleanBuilderParagraphInput(getBuilderString(description, locale))
        )}
      </div>
    </header>
  );
};
